// Shared section-detection constants used by both extractText.ts and draw-resume-pages.ts.

export const MAIN_SECTION_RE =
  /^(experience|professional\s+(?:work\s+)?(?:experience|summary)|work\s+experience|other\s+(?:work\s+)?experiences?|additional\s+(?:work\s+)?experiences?|employment\s+(?:history|record)|career\s+(?:summary|history|objective|profile)|education(?:al\s+(?:background|attainment|qualification))?|(?:seminar|training)s?\s*(?:attended|and\s+training)?|personal\s+(?:information|data|background|details?)|profile\s+summary|summary\s+(?:of\s+)?(?:qualifications?|experience|skills?)|objective)\s*:?\s*$/i;

export const SUB_SECTION_RE =
  /^(skills?\s*(?:summary)?|core\s+competenc(?:y|ies)|technical\s+skills?|key\s+skills?|character\s+references?|references?|certifications?\s*(?:and\s+(?:awards?|honors?|recognition))?|awards?\s*(?:and\s+(?:certifications?|honors?|recognition))?|honors?\s*(?:and\s+awards?)?|contact\s+(?:information|details?)|languages?\s*(?:skills?)?|hobbies?\s*(?:and\s+interests?)?|interests?\s*(?:and\s+hobbies?)?|achievements?|accomplishments?|(?:professional\s+)?projects?|publications?|volunteer(?:ing)?\s+(?:experience|work)?|activities?)\s*:?\s*$/i;

// Matches Philippine mobile/landline and international formats.
// Used in extraction (contact-section band signal) and in PDF rendering (suppress from output).
export const PHONE_NUMBER_RE =
  /^[+]?[\d][\d\s\-().]{6,18}[\d](?:\s*\/\s*[+]?[\d][\d\s\-().]{6,18}[\d])*$/;

// Canonical list of known section header strings — grows over time via the section_headers DB table.
export const KNOWN_SECTION_HEADERS: string[] = [
  // Main sections
  "Work Experience", "Professional Experience", "Employment History",
  "Experience",
  "Career History", "Career Summary", "Career Objective", "Career Profile",
  "Education", "Educational Background", "Educational Attainment",
  "Seminars Attended", "Trainings Attended", "Personal Information",
  "Profile Summary", "Summary of Qualifications", "Objective",
  // Sub-sections
  "Skills", "Core Competencies", "Technical Skills", "Key Skills",
  "Character References", "References", "Certifications", "Awards",
  "Contact Information", "Contact Details", "Languages", "Hobbies and Interests",
  "Achievements", "Accomplishments", "Projects", "Publications",
  "Volunteer Experience", "Activities", "Other Experiences",
];

const JOB_ENTRY_RE =
  /\b(?:(?:jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:tember)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)\s+)?(?:19|20)\d{2}\s*(?:[-–—]|\s+to)\s*(?:(?:jan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:tember)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?)\s+)?(?:(?:19|20)\d{2}|present|current|now)\b/i;

export const isMainHeader = (s: string, inWorkExpCtx = false): boolean => {
  if (JOB_ENTRY_RE.test(s)) return false;
  if (s.length <= 70 && MAIN_SECTION_RE.test(s)) return true;
  if (inWorkExpCtx) return false;
  const upper = (s.match(/[A-Z]/g) ?? []).length;
  return s.length <= 60 && upper >= 3 && !/[a-z]/.test(s);
};

export const isSubHeader = (s: string): boolean =>
  !JOB_ENTRY_RE.test(s) && s.length <= 70 && SUB_SECTION_RE.test(s);

export const isHeaderLine = (s: string, inWorkExpCtx = false): boolean =>
  isMainHeader(s, inWorkExpCtx) || isSubHeader(s);
